<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
<div>
  {{news.textParams[0]}}
  {{$t('news.template.elected.valNew.p1')}}
  {{news.textParams[1]}} {{news.textParams[2]}}!
</div>
</template>
